export default "__VITE_ASSET__93e665e4__"